module.exports = __webpack_public_path__ + "static/media/minus.abddbc25.svg";